import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      courseList: [],
      selectedCourseIdx: 0,
      majorList: [],
      activeMajorIdx: "0",
      majorType: 0,
      category: 2,
      searchName: "",
      enrolledExamMap: {}
    };
  },
  computed: {
    categoryTitle() {
      const map = {
        0: "专家讲义",
        1: "教材",
        2: "教学大纲"
      };
      return map[this.category] || "课程";
    },
    searchPlaceholder() {
      return `请输入${this.categoryTitle}名称`;
    },
    majorTypeLabel() {
      const map = {
        0: "专科护士培训",
        1: "专项护士培训",
        2: "专题护士培训",
        3: "师资护士培训"
      };
      return map[this.majorType] || "护理培训";
    },
    categoryLabel() {
      const map = {
        0: "讲义",
        1: "教材",
        2: "大纲"
      };
      return map[this.category] || "课程";
    }
  },
  created: function() {
    this.syncRouteFilters();
    this.loadMajorList();
  },
  watch: {
    $route(to, from) {
      if (to.path !== "/courseList") {
        return;
      }
      const prevKey = `${from.query.majorType || ""}_${from.query.category ||
        ""}`;
      const nextKey = `${to.query.majorType || ""}_${to.query.category || ""}`;
      if (prevKey !== nextKey) {
        this.searchName = "";
      }
      this.syncRouteFilters();
      this.loadMajorList();
    }
  },
  methods: {
    goHome() {
      this.$router.push("/home");
    },
    goStudyPage() {
      this.$router.push("/studyPage");
    },
    syncRouteFilters() {
      const routeMajorType = Number(this.$route.query.majorType);
      this.majorType = Number.isFinite(routeMajorType) ? routeMajorType : 0;

      const routeCategory = Number(this.$route.query.category);
      this.category = [0, 1, 2].includes(routeCategory) ? routeCategory : 2;
    },
    async loadMajorList() {
      const loadingInstance = this.$loading({ text: "加载中" });
      await this.loadEnrolledExamMap();
      const res = await httpRequest("/app/major/majors", "get", {
        majorType: this.majorType
      });
      if (res !== null && res !== undefined && res.code === 200) {
        this.majorList = Array.isArray(res.data) ? res.data : [];
        this.activeMajorIdx = "0";
        await this.loadCourseList();
      } else {
        this.majorList = [];
        this.courseList = [];
      }
      loadingInstance.close();
    },
    async loadEnrolledExamMap() {
      this.enrolledExamMap = {};
      try {
        const res = await httpRequest(
          "/app/exam/exam/yet-enroll-exams",
          "get",
          {
            majorType: this.majorType
          }
        );
        if (!res || res.code !== 200 || !Array.isArray(res.data)) {
          return;
        }
        res.data.forEach(exam => {
          const majorId = Number(exam && exam.majorId);
          if (!Number.isFinite(majorId) || majorId <= 0) {
            return;
          }
          if (!this.enrolledExamMap[majorId]) {
            this.enrolledExamMap[majorId] = exam;
          }
        });
      } catch (error) {
        void error;
      }
    },
    parseDateTime(value) {
      if (!value) {
        return null;
      }
      const normalized = String(value).replace(/-/g, "/");
      const parsed = new Date(normalized);
      if (!Number.isNaN(parsed.getTime())) {
        return parsed;
      }
      const fallback = new Date(value);
      return Number.isNaN(fallback.getTime()) ? null : fallback;
    },
    formatDateTime(value) {
      const date = this.parseDateTime(value);
      if (!date) {
        return "-";
      }
      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, "0");
      const day = `${date.getDate()}`.padStart(2, "0");
      const hour = `${date.getHours()}`.padStart(2, "0");
      const minute = `${date.getMinutes()}`.padStart(2, "0");
      const second = `${date.getSeconds()}`.padStart(2, "0");
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    isEnrolledForCourse(course) {
      if (!course) {
        return false;
      }
      const hasApplyField = Object.prototype.hasOwnProperty.call(
        course,
        "apply"
      );
      const hasCanBrowseField = Object.prototype.hasOwnProperty.call(
        course,
        "canBrowse"
      );
      if (hasApplyField) {
        return !!course.apply;
      }
      if (hasCanBrowseField) {
        return course.canBrowse === true || Number(course.canBrowse) === 1;
      }
      return false;
    },
    getCourseExamInfo(course) {
      const majorId = Number(course && course.majorId);
      if (!Number.isFinite(majorId) || majorId <= 0) {
        return null;
      }
      return this.enrolledExamMap[majorId] || null;
    },
    isBeforeTheoryStudyStart(exam) {
      const start = this.parseDateTime(exam && exam.examStartTime);
      if (!start) {
        return false;
      }
      return Date.now() < start.getTime();
    },
    getTheoryStudyLockedMessage(exam) {
      const start = this.formatDateTime(exam && exam.examStartTime);
      const end = this.formatDateTime(exam && exam.examEndTime);
      return `暂未开启，理论学习时间：${start}~${end}`;
    },
    getCourseLockMessage(course) {
      if (!course) {
        return "课程信息异常";
      }
      if (!this.isEnrolledForCourse(course)) {
        return "请先报名对应培训班";
      }
      const exam = this.getCourseExamInfo(course);
      if (exam && this.isBeforeTheoryStudyStart(exam)) {
        return this.getTheoryStudyLockedMessage(exam);
      }
      if (
        Object.prototype.hasOwnProperty.call(course, "canBrowse") &&
        !(course.canBrowse === true || Number(course.canBrowse) === 1)
      ) {
        return exam
          ? this.getTheoryStudyLockedMessage(exam)
          : "当前课程暂不可访问";
      }
      return "";
    },
    async loadCourseList() {
      const major = this.majorList[Number(this.activeMajorIdx)];
      if (!major || !major.majorId) {
        this.courseList = [];
        return;
      }

      const loadingInstance = this.$loading({ text: "加载中" });
      const params = {
        majorId: major.majorId,
        nameParam: this.searchName || "",
        category: this.category
      };
      const res = await httpRequest("/app/course/rich/courses", "get", params);
      if (res !== null && res !== undefined && res.code === 200) {
        this.courseList = Array.isArray(res.data) ? res.data : [];
      } else {
        this.courseList = [];
      }
      loadingInstance.close();
    },
    handleSearch() {
      this.loadCourseList();
    },
    isCourseLocked(course) {
      return !!this.getCourseLockMessage(course);
    },
    getLearnNum(course) {
      const learnNum = Number(course && course.learnNum);
      return Number.isFinite(learnNum) && learnNum > 0 ? learnNum : 0;
    },
    go2CourseContentPage(course) {
      const lockMessage = this.getCourseLockMessage(course);
      if (lockMessage) {
        this.$message.warning(lockMessage);
        return;
      }
      const rtcId = Number(course && course.rtcId);
      if (!Number.isFinite(rtcId) || rtcId <= 0) {
        this.$message.warning("课程信息异常");
        return;
      }
      this.$router.push({
        path: "/courseContent",
        query: {
          rtcId,
          majorType: this.majorType,
          category: this.category
        }
      });
    }
  }
};
